import React from 'react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
export function FinalCta() {
  return <section className="bg-sand py-12 sm:py-16" data-id="element-53" data-mp="vghhfpe10dp0">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-54" data-mp="19ez3lioa9i4t">
        <p className="font-sans text-[0.66rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-55" data-mp="19gih51ik1f2w">
          Wellness Digital Pro™
        </p>
        <h2 className="mt-3 font-display text-2xl font-semibold leading-tight text-charcoal sm:text-3xl" data-id="element-56" data-mp="1jcvce3tr00zr">
          Empezá hoy con todo resuelto
        </h2>
        <p className="mt-2 font-sans text-sm font-semibold text-charcoal/75 sm:text-base" data-id="element-57" data-mp="1eds6yi9uvsr9">
          MegaPack 6 en 1 + 5 bonos
        </p>

        <PriceBlock className="mt-5" size="lg" data-id="element-58" data-mp="1o43mz36tdsei" />

        <div className="mt-5 flex justify-center" data-id="element-59" data-mp="1o4d9ggsnhhfg">
          <CTAButton className="w-full max-w-[22rem] whitespace-nowrap px-5" data-id="element-60" data-mp="22339a46utv7i" />
        </div>

        <p className="mt-2.5 font-sans text-[0.72rem] text-charcoal/60" data-id="element-61" data-mp="1x4tevvsyeymy">
          Acceso inmediato · Pago seguro · Garantía 7 días
        </p>
      </div>
    </section>;
}